import { render, staticRenderFns } from "./register-mradio.vue?vue&type=template&id=5f8b3b6f&scoped=true&"
import script from "./register-mradio.vue?vue&type=script&lang=js&"
export * from "./register-mradio.vue?vue&type=script&lang=js&"
import style0 from "./register-mradio.vue?vue&type=style&index=0&id=5f8b3b6f&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8b3b6f",
  null
  
)

export default component.exports